import { jsonParse, jsonStringify } from '@lyearn/core/utils/json';

export default class Storage {
  private get storage() {
    return global.localStorage;
  }

  localObject: { [key: string]: string } = {};

  public getData = <TData>(key: string) => {
    let stringifiedData;
    try {
      stringifiedData = this.storage.getItem(key);
    } catch (error) {
      console.log(error);
      stringifiedData = this.localObject[key];
    }
    if (stringifiedData) {
      const { data } = jsonParse<TData>(stringifiedData);
      return data;
    }
  };

  public setData = (key: string, data: object) => {
    const stringifiedData = jsonStringify(data).data;
    if (stringifiedData) {
      try {
        this.storage.setItem(key, stringifiedData);
      } catch (error) {
        console.log(error);
        this.localObject[key] = stringifiedData;
      }
    }
  };
}
